import { FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Button from 'src/common/components/ButtonDS22';
import Quote from './Quote';
import styles from './QuotesSection.module.scss';

const quotes = Array.from({ length: 6 }, (_, i) => i);

const QuotesSection: FC = () => {
  const [t] = useTranslation('press-page');
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <PitchPageLayout backgroundColor="ivory">
      <dl className={getClassNames(styles, 'list', classNames({ isExpanded }))}>
        {quotes.map((index) => (
          <Quote
            key={`quote-${index}`}
            quote={t(`quote-${index}`)}
            outlet={t(`outlet-${index}`)}
          />
        ))}
      </dl>
      {!isExpanded && (
        <div className={styles.button}>
          <Button
            variant="tertiary"
            onClick={() => setIsExpanded(true)}
          >
            {t('quotes--button')}
          </Button>
        </div>
      )}
    </PitchPageLayout>
  );
};

export default QuotesSection;
